export default __webpack_public_path__ + "static/media/FacebookClone5.e24a6b81.png";